import { React, useEffect, useState } from 'react';
import { isMobile } from 'react-device-detect';
import { useMsal } from "@azure/msal-react";
import { useNavigate } from 'react-router-dom';
import { vaildateToken } from '../../api/auth';
import AuthImage from '../../component/AuthImage';

function PbsCts() {
    const { instance, accounts } = useMsal();
    const activeAccount = instance.getActiveAccount();

    const navigate = useNavigate();

    useEffect(() => {
        if (!activeAccount) {
            navigate("/mes");
        }
    }, [activeAccount]);

    useEffect(() => {
        setTimeout(async () => {
                try {
                    const result = await vaildateToken();
                } catch (error) {
                    console.log('error', error);
                    alert(error.message);
                }
        }, 100);
    }, []);

    function onClickClose() {
        window.close();
    }

    return (
        <div className='w-full p-2'>
            <div className={`${isMobile ? "" : "hidden"} fixed bottom-2 right-2`}>
                <button className="border border-black rounded-sm px-2 py-0.5 m-1 bg-white hover:bg-gray-400" onClick={onClickClose}>
                    CLOSE
                </button>
            </div>
            <AuthImage filename="pbs.png" alt="PBS" style={{ width: '100%' }} />
            <br />
            <AuthImage filename="assy.png" alt="ASSY" style={{ width: '100%' }} />
            <br />
            <AuthImage filename="screenshot.png" alt="SCREENSHOT" style={{ width: '100%' }} />
            <br />
            <AuthImage filename="shipping.png" alt="SHIPPING" style={{ width: '100%' }} />
        </div>
    )
}

export default PbsCts;
